import _ from 'lodash'

export const getValue = ({ list, value, valueField, labelField }: any) => {
  const foundItem = _.find(
    list,
    (item) => _.property(valueField)(item) === value
  )

  if (foundItem) {
    return { value: _.property(valueField)(foundItem), label: _.property(labelField)(foundItem) }
  }

  return {}
}
export const getOptions = ({ list, valueField, labelField }: any) => {
  const data: any = _.map(
    list,
    (option: any) => ({ value: _.property(valueField)(option), label: _.property(labelField)(option) })
  );
  return data
}
